import { gql } from '@apollo/client';
import {
  LibraryBrandShopFragment,
  LibraryBrandShopMinifiedFragment,
} from './libraryBrandShop';
import {
  ILibraryCategoryShop,
  LibraryCategoryShopFragment,
} from './libraryCategoryShop';
import { LibraryOpeningHoursFragment } from './libraryOpeningHours';
import { LibraryOpeningHoursExceptionsFragment } from './libraryOpeningHoursException';
import { LibrarySocialMediaLinksFragment } from './librarySocialMediaLinks';
import { TTenantTypes } from './meetingPlacePageTenantList';
import {
  LibraryBrandFoodBeverageFragment,
  LibraryBrandFoodBeverageMinifiedFragment,
} from './libraryBrandFoodBeverage';
import {
  LibraryBrandEntertainmentFragment,
  LibraryBrandEntertainmentMinifiedFragment,
} from './libraryBrandEntertainment';

export interface ICircularServicesTags {
  tagName: string;
  type: string;
  colour: string;
}

export interface IMeetingPlacePageTenantShopItem {
  __typename: string;
  sys: {
    id: string;
    locale: string;
  };
  brand: any;
  name: string;
  slug: string;
  logo: any;
  coverImage: any;
  description: any;
  contactDetails: any;
  primaryCategory: any;
  secondaryCategoriesCollection: {
    items: ILibraryCategoryShop[];
  };
  openingHours: any;
  openingHoursExceptionsCollection: { items: any };
  socialMediaLinks: any;
  customizedSlug: string;
  // node_locale: string;
  seoDescription: any;
  floorPlanIDs: string[];
  unitId?: string[];
  giftCard: boolean;
  loyaltyCard: boolean;
  isItAMultiBrandStore?: string;
  subShopsListTitle?: string;
  subShopItemCollection?: {
    items: TTenantTypes[];
  };
  hasOffer?: boolean;
  hasEvent?: boolean;
  offerCampaignNames?: string[];
  circularServicesCollection: { items: ICircularServicesTags[] };
}

export const MeetingPlacePageTenantShopItemFragment = gql`
  ${LibraryBrandShopFragment}
  ${LibraryBrandFoodBeverageFragment}
  ${LibraryBrandEntertainmentFragment}
  ${LibraryOpeningHoursFragment}
  ${LibraryOpeningHoursExceptionsFragment}
  ${LibrarySocialMediaLinksFragment}
  fragment MeetingPlacePageTenantShopItem on MeetingPlacePageTenantShop {
    __typename
    sys {
      id
      locale
    }
    floorPlanIDs
    unitId
    brand {
      ... on LibraryBrandShop {
        ...LibraryBrandShop
      }
      ... on LibraryBrandFoodBeverage {
        ...LibraryBrandFoodBeverage
      }
      ... on LibraryBrandEntertainment {
        ...LibraryBrandEntertainment
      }
    }
    name
    slug
    logo {
      description
      url
      width
      height
    }
    coverImage {
      description
      url
      height
      width
    }
    description {
      json
    }
    contactDetails {
      json
    }
    primaryCategory {
      ...LibraryCategoryShop
    }
    secondaryCategoriesCollection(limit: 10) {
      items {
        ...LibraryCategoryShop
      }
    }
    openingHours {
      ...LibraryOpeningHours
    }
    openingHoursExceptionsCollection {
      items {
        ... on LibraryOpeningHoursException {
          ...LibraryOpeningHoursExceptions
        }
      }
    }
    socialMediaLinks {
      ...LibrarySocialMediaLinks
    }
    seoDescription
    giftCard
    loyaltyCard
    circularServicesCollection {
      items {
        colour
        type
        tagName
      }
    }
  }
`;

export const MeetingPlacePageTenantShopItemMinifiedFragment = gql`
  ${LibraryBrandShopMinifiedFragment}
  ${LibraryBrandFoodBeverageMinifiedFragment}
  ${LibraryBrandEntertainmentMinifiedFragment}
  ${LibraryCategoryShopFragment}
  fragment MeetingPlacePageTenantShopItemMinified on MeetingPlacePageTenantShop {
    __typename
    sys {
      id
    }
    name
    brand {
      ... on LibraryBrandShop {
        ...LibraryBrandShopMinified
      }
      ... on LibraryBrandFoodBeverage {
        ...LibraryBrandFoodBeverageMinified
      }
      ... on LibraryBrandEntertainment {
        ...LibraryBrandEntertainmentMinified
      }
    }
    logo {
      description
      url
      height
      width
    }
    primaryCategory {
      ...LibraryCategoryShop
    }
    secondaryCategoriesCollection(limit: 10) {
      items {
        ...LibraryCategoryShop
      }
    }
  }
`;

export const MeetingPlacePageTenantShopItemMinifiedLogoFragment = gql`
  fragment MeetingPlacePageTenantShopItemMinifiedLogo on MeetingPlacePageTenantShop {
    __typename
    sys {
      id
    }
    name
    brand {
      ... on LibraryBrandShop {
        sys {
          id
          locale
        }
        name
        slug
        logo {
          description
          url
          height
          width
        }
      }
      ... on LibraryBrandFoodBeverage {
        sys {
          id
          locale
        }
        name
        slug
        logo {
          description
          url
          height
          width
        }
      }
      ... on LibraryBrandEntertainment {
        sys {
          id
          locale
        }
        name
        slug
        logo {
          description
          url
          height
          width
        }
      }
    }
    logo {
      description
      url
      height
      width
    }
  }
`;

export const MeetingPlacePageTenantShopListItemFragment = gql`
  ${LibraryBrandShopMinifiedFragment}
  ${LibraryBrandFoodBeverageMinifiedFragment}
  ${LibraryBrandEntertainmentMinifiedFragment}
  ${LibraryCategoryShopFragment}
  fragment MeetingPlacePageTenantShopListItem on MeetingPlacePageTenantShop {
    __typename
    sys {
      id
      locale
    }
    name
    brand {
      ... on LibraryBrandShop {
        ...LibraryBrandShopMinified
      }
      ... on LibraryBrandFoodBeverage {
        ...LibraryBrandFoodBeverageMinified
      }
      ... on LibraryBrandEntertainment {
        ...LibraryBrandEntertainmentMinified
      }
    }
    slug
    logo {
      description
      url
      height
      width
    }
    coverImage {
      description
      url
      height
      width
    }
    primaryCategory {
      ...LibraryCategoryShop
    }
    secondaryCategoriesCollection(limit: 10) {
      items {
        ...LibraryCategoryShop
      }
    }
    giftCard
    loyaltyCard
  }
`;

